import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./Style.css";
import Logo from '../assets/Logos/TNG_global_v2-04.png';

function Navbar() {
  const location = useLocation();

  useEffect(() => {
    const hamburger = document.querySelector(".hamburger");
    const navMenu = document.querySelector(".nav-menu");

    const toggleMenu = () => {
      navMenu.classList.toggle("active");
    };

    hamburger?.addEventListener("click", toggleMenu);

    return () => {
      hamburger?.removeEventListener("click", toggleMenu);
    };
  }, []);

  return (
    <div className="navbar">
      <div className="logo">
        <NavLink to="/">
          <img src={Logo} alt="Logo" />
        </NavLink>
      </div>

      <div className="hamburger">☰</div>

      <nav className="nav-menu">
        <ul>
          <li>
            <a href="/">Overview</a>
          </li>
          <li>
            <NavLink to="/brands">Brands</NavLink>
          </li>
          <li>
            <NavLink to="/our-core-values">Our Values</NavLink>
          </li>
          {/* <li>
            <a href="/#Features">Features</a>
          </li>
          <li>
            <a href="/#Destinations">Destinations</a>
          </li>
          <li>
            <a href="/#Packages">Packages</a>
          </li> */}
          <li>
            <NavLink to="/contact-us">Contact Us</NavLink>
          </li>
        </ul>
      </nav>

      {/* <NavLink to="/account">
        <button className="login-button" id="MyAccount">
          Login / Register
        </button>
      </NavLink> */}
    </div>
  );
}

export default Navbar;
